import { Docket, DocketStatus, OrbDeviceConfig } from '@oolio-group/domain';
import { Organization, Store } from '@/types/common';
import { authServiceInstance } from '@/services/authServiceInstance';
import { APP_CONFIG } from '@/config';
import { apiClient } from '@/services/apiClient';
import { DocketResponse } from '@/hooks/useDockets';

export const fetchDocketsFromAPI = async ({
  orbConfig,
  store,
  organization,
}: {
  orbConfig: OrbDeviceConfig;
  store: Store;
  organization: Organization;
}): Promise<Docket[]> => {
  const docketServiceUrl = `${APP_CONFIG.DOCKET_SERVICE_URI}/dockets`;
  const authHeaders = authServiceInstance.getAuthHeaders();
  const basePayload = {
    ids: orbConfig.printerProfileIds,
    storeId: store.id,
    orgId: organization.id,
  };

  const [createdResponse, completedResponse] = await Promise.all([
    apiClient.post<DocketResponse>(
      docketServiceUrl,
      {
        ...basePayload,
        status: DocketStatus.CREATED,
      },
      authHeaders,
    ),
    apiClient.post<DocketResponse>(
      docketServiceUrl,
      {
        ...basePayload,
        status: DocketStatus.COMPLETED,
      },
      authHeaders,
    ),
  ]);

  return [
    ...(createdResponse?.dockets || []),
    ...(completedResponse?.dockets || []),
  ];
};
